import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { useLang } from "@/lib/i18n";

const reveal = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export default function Faq() {
  const { t } = useLang();

  return (
    <section
      id="faq"
      className="py-24 md:py-32 border-t border-[#2D2520]"
      data-testid="faq-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <motion.div {...reveal} transition={{ duration: 0.8 }} className="lg:col-span-5">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#D48C46] mb-5">
            {t.faq.label}
          </p>
          <h2 className="font-serif font-medium text-4xl sm:text-5xl tracking-tight leading-tight text-[#F9F6F0]">
            {t.faq.title}
          </h2>
          <p className="mt-6 text-base md:text-lg leading-relaxed text-[#A69C95] max-w-md">
            {t.faq.body}
          </p>
        </motion.div>

        <motion.div
          {...reveal}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="lg:col-span-7"
        >
          <Accordion type="single" collapsible className="w-full">
            {t.faq.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-[#2D2520]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="text-left font-serif text-xl sm:text-2xl text-[#F9F6F0] hover:text-[#D48C46] hover:no-underline py-6 transition-colors duration-300"
                  data-testid={`faq-trigger-${i}`}
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent
                  className="text-sm md:text-base leading-relaxed text-[#A69C95] pb-6"
                  data-testid={`faq-content-${i}`}
                >
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
